"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollLock = useScrollLock;
const react_1 = require("react");
function useScrollLock(enabled) {
    (0, react_1.useEffect)(() => {
        if (!enabled) {
            return undefined;
        }
        scrollLocker.lock();
        return () => {
            scrollLocker.unlock();
        };
    }, [enabled]);
}
class ScrollLocker {
    constructor() {
        this.lockCount = 0;
        this.scrollPosition = 0;
        this.originalOverflow = '';
        this.originalPaddingRight = '';
        this.lock = () => {
            if (this.lockCount === 0) {
                this.lockScreen();
            }
            this.lockCount += 1;
        };
        this.unlock = () => {
            this.lockCount -= 1;
            if (this.lockCount === 0) {
                this.unlockScreen();
            }
            if (this.lockCount < 0) {
                this.lockCount = 0;
            }
        };
        this.lockScreen = () => {
            this.scrollPosition = window.scrollY;
            this.originalOverflow = document.body.style.overflow;
            this.originalPaddingRight = document.body.style.paddingRight;
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            if (scrollbarWidth > 0) {
                document.body.style.paddingRight = `${scrollbarWidth}px`;
            }
        };
        this.unlockScreen = () => {
            document.body.style.overflow = this.originalOverflow;
            document.body.style.paddingRight = this.originalPaddingRight;
            window.scrollTo(0, this.scrollPosition);
        };
    }
}
const scrollLocker = new ScrollLocker();
